import store from '@/store';
import Brand from './Brand';

class RiskResources {
	private oldUrls: string[] = [
		'https://api.test.starlabs.cloud/',
		'http://api.test.starlabs.cloud/',
		'https://api.constellationmutual.com/',
		'https://wp-api.constellationmutual.com/',
		'https://www.mmicgroup.com/myaccount/riskportal/index.php/risk-management/',
		'http://www.mmicgroup.com/myaccount/riskportal/index.php/risk-management/',
		'https://staging.mmicgroup.com/myaccount/riskportal/index.php/risk-management/',
		'http://staging.mmicgroup.com/myaccount/riskportal/index.php/risk-management/',
	];

	private newUrlPrefix = '/risk-resources/';

	/**
	 * Sidebars
	 */
	private sidebars = ['bundled-solutions', 'tools-and-resources'];

	/**
	 * Breaks down the url to give the last item in the url, aka page slug.
	 *
	 * @param path string
	 */
	public getSlug(path: string, item?): string {
		console.log(path);
		const splitPath = path.split('/');
		const countItems = splitPath.length;

		if (item === undefined) {
			item = countItems;
		}

		return splitPath[item - 1];
	}

	public getSidebarSlug(path: string): string {
		for (const sidebar of this.sidebars) {
			if (path.includes(sidebar)) {
				return sidebar;
			}
		}

		return undefined;
	}

	/**
	 * Replaces the links in the content with the correct path,
	 * this is because WordPress always add the site url to internal links
	 * and we don't want that. We also look for older urls just in case a link
	 * doesn't get updated.
	 */
	public updateLinks(content: string, justUrl = true): string {
		let updatedContent = content;

		updatedContent = this.replacePlaceholders(updatedContent);

		try {
			const url = new URL(content);
			if (justUrl && this.oldUrls.indexOf(url.origin + '/') < 0) {
				return content;
			}
		} catch {
			// Nothing in here.
		}

		for (const url of this.oldUrls) {
			const re = new RegExp(url, 'g');
			updatedContent = updatedContent.replace(re, this.newUrlPrefix);
		}

		if (justUrl && updatedContent.indexOf(this.newUrlPrefix) < 0) {
			updatedContent = this.newUrlPrefix + updatedContent;
		}

		return updatedContent.replace(/\/$/, '');
	}

	public replacePlaceholders(content: string): string {
		const replaceItems = {
			brand: {
				replace: Brand.getProperBrand(),
				find: new RegExp('{{BRAND}}', 'g'),
			},
			brandPhoneNumber: {
				replace: Brand.getBrandInformation().phone_number,
				find: new RegExp('{{BRAND_PHONENUMBER}}', 'g'),
			},
			brandEmailAddress: {
				replace: Brand.getBrandInformation().email_address,
				find: new RegExp('{{BRAND_EMAILADDRESS}}', 'g'),
			},
			brandURL: {
				replace: Brand.getBrandInformation().domain,
				find: new RegExp('{{BRAND_URL}}', 'g'),
			},
		};

		Object.keys(replaceItems).map((i: any) => {
			const item: any = replaceItems[i];
			content = content.replace(item.find, item.replace);
		});

		return content;
	}

	/**
	 * Check to see if the page has access to the current branded myacount portal.
	 * If not, 404 not found.
	 * @param page object
	 */
	public brandHasAccess(page) {


		// Super kludge... I'm guessing that the acf.brands stuff is populated via wordpress 
		// or something?  We are going to just ignore this for the moment
		// 
		try {
		    if (Brand.getBrand() === 'rrg') {
			return true;
		    }
		} catch (e) {
			return false;
		}
/*
 Does ANYTHING not have access??? -Ivan
*/
		try {
			if (
				page.acf !== undefined &&
				page.acf.brands !== undefined &&
				(( page.acf.brands.includes(Brand.getBrand()) )  || ( page.acf.brands.includes('mmic') && (Brand.getBrand() === 'rrg')  ))	// New kludge.. just give RRG same settings as MMIC
			) {
				return true;
			}
		} catch (e) {
			return false;
		}
	}

	public async whichApiToCall(pagePath: string) {
		if (pagePath.indexOf('claim-reviews') > -1 && this.getSlug(pagePath) !== 'claim-reviews') {
			await store.dispatch('RiskResources/getClaimReview', pagePath);
			return;
		} else if (pagePath.indexOf('claim-reviews') > -1) {
			await store.dispatch('RiskResources/getClaimReviews');
			return;
		}

		if (
			pagePath.indexOf('news-and-events') > -1 &&
			this.getSlug(pagePath) !== 'news-and-events'
		) {
			await store.dispatch('RiskResources/getNewsArticle', pagePath);
			return;
		} else if (pagePath.indexOf('news-and-events') > -1) {
			await store.dispatch('RiskResources/getNewsArticles');
			return;
		}

		if (
			pagePath.indexOf('on-demand-webinars') > -1 &&
			this.getSlug(pagePath) !== 'on-demand-webinars'
		) {
			await store.dispatch('RiskResources/getOnDemandWebinar', pagePath);
			return;
		} else if (pagePath.indexOf('on-demand-webinars') > -1) {
			await store.dispatch('RiskResources/getOnDemandWebinars');
			return;
		}

		await store.dispatch('RiskResources/getPage', pagePath);
		return;
	}

	/**
	 * List the correct category names for posts
	 */
	public transformCategories(data: any, category: string): string {
		const storedCategory = store.state.RiskResources[category];

		const categoryList: string[] = [];

		data.map(cat => {
			const find = storedCategory.find(c => c.id === cat);
			if (find !== undefined) {
				categoryList.push(find.name.replace('&amp;', '&'));
			}

			return cat;
		});

		return categoryList.join(', ');
	}

	public transformCategoriesToFilterClass(data: any, category: string): string {
		const storedCategory = store.state.RiskResources[category];

		const categoryList: string[] = [];

		data.map(cat => {
			const find = storedCategory.find(c => c.id === cat);
			if (find !== undefined) {
				categoryList.push('filter-' + find.slug);
			}

			return cat;
		});

		return categoryList.join(' ');
	}

	public decodeHTML(str) {
		return str.replace(/&#([0-9]{1,3});/gi, (match, num) => {
			return String.fromCharCode(parseInt(num, 10));
		});
	}
}

export default new RiskResources();
